import React from 'react';
import { Navigate, RouteObject } from 'react-router-dom';
import { PermissionsProtectedRoute } from 'client/routes/PermissionsProtectedRoute';
import { teamPermissions } from '../team/permissions/Team';

const PurgeSchedule = React.lazy(() => import('./PurgeSchedule'));

export const purgeRoutes: RouteObject = {
  path: 'purge',
  element: (
    <PermissionsProtectedRoute
      pageId={teamPermissions.pageId}
      currentPath="/purge"
    />
  ),
  children: [
    { path: '*', element: <Navigate to="/404" /> },
    {
      path: '/purge',
      element: <Navigate to="/purge/schedule" />,
    },
    {
      path: '/purge/schedule',
      element: (
        <React.Suspense fallback={undefined}>
          <PurgeSchedule />
        </React.Suspense>
      ),
    },
  ],
};
